export class RuntimeManager {
  constructor(devtools) {
    this.devtools = devtools;
    this.errors = [];
    this.operations = [];
    this.realTimeUpdates = true;
  }

  logOperation(operation) {
    const timestamp = Date.now();
    const operationData = {
      id: `op_${timestamp}_${Math.random().toString(36).substr(2, 9)}`,
      type: operation.type,
      data: operation.data,
      timestamp,
      stackTrace: this.captureStackTrace()
    };

    this.operations.push(operationData);
    
    if (this.realTimeUpdates) {
      this.devtools.uiManager.updateOperations(operationData);
    }

    return operationData;
  }

  captureStackTrace() {
    const stack = new Error().stack;
    return stack ? stack.split('\n').slice(2) : [];
  }

  getRecentOperations(limit = 50) {
    return this.operations.slice(-limit);
  }

  clearOperations() {
    this.operations = [];
  }
}